import React from 'react';
import { useDispatch, useSelector } from 'react-redux';

import { getSurveyResults } from '../../../redux/survey/survey_results/actions';
import MainContainer from '../../../components/main_container/MainContainer';
import { tabsOptions } from './tabsOptions';
import CustomTabs from '../../../components/tabs/CustomTabs';
import CustomBreadcrumb from '../../../components/custom_breadcrumb/CustomBreadcrumb';

const SurveyResult = (props) => {

  const { surveyResults } = useSelector(state => state.surveyResults);
  const [filterTestDataMode, setFilterTestDataMode] = React.useState(false);

  const dispatch = useDispatch();
  React.useEffect(() => {
    dispatch(getSurveyResults({ survey_id: props.match.params.id, modo_prueba: filterTestDataMode }));
  }, [props.match.params.id, dispatch, filterTestDataMode]);

  return (
    <MainContainer>
      <CustomBreadcrumb breadcrumbs={[{ name: 'Encuestas', link: '/encuestas' }, { name: `Resultados de encuesta / evaluación ${surveyResults.length > 0 ? surveyResults[0].survey_name : ''}`, active: true }]} />
      <h5 className="my-3">Resultados de encuesta / evaluación</h5>
      <CustomTabs
        defaultActiveKey="tables"
        id="surveyResultTabs"
        tabs={tabsOptions(setFilterTestDataMode)} />
    </MainContainer>
  )
}

export default SurveyResult